
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as previewfyxoZ4798HWr52u2_PUHvx91MysEp7ADfjGcV4vaxUQMeta } from "/usr/src/app/apps/site-sk/app/pages/cms/preview.vue?macro=true";
import { default as preview_45frame7dTt7di272RbevGa9AHSLywnB5O6vUrvlYzddywTAoUMeta } from "/usr/src/app/apps/site-sk/app/pages/cms/preview-frame.vue?macro=true";
import { default as teamsQpBKgyG7Iqbx5NmXd_zuzpRgNNBkTpPIXSzTIiBkjvAMeta } from "/usr/src/app/apps/site-sk/app/pages/onboarding/teams.vue?macro=true";
import { default as confirmationxrFy6XxLBrrYy1w165IrVudr8NC6g6znTSfh_KbzVSAMeta } from "/usr/src/app/apps/site-sk/app/pages/order/confirmation.vue?macro=true";
import { default as warranty17iq113BMNrtd_byX81D62BxXsdEaFhuNu1bUwnvfsIMeta } from "/usr/src/app/apps/site-sk/app/pages/support/warranty.vue?macro=true";
import { default as _91uid_936xZayM4q_hba2veOoUMptrinWJslT3v_XYM0VEMGZXMMeta } from "/usr/src/app/apps/site-sk/app/pages/accept-invitation/[uid].vue?macro=true";
import { default as _91uid_93NpdWdLZPeZKF6TsmHEk_fovSfJVOCQ6f_L7y6jVoDmYMeta } from "/usr/src/app/apps/site-sk/app/pages/order-line/[uid].vue?macro=true";
import { default as _91orderUid_935PrLycAXHRbu_uxmpn2rHIUPJ8tjEfCIShJLkUMPdw4Meta } from "/usr/src/app/apps/site-sk/app/pages/return/[orderUid].vue?macro=true";
import { default as _91uid_93MvA_XjWWZYhHfLZx7WxNXcWQuTRrk5TjseWxLAuhuTsMeta } from "/usr/src/app/apps/site-sk/app/pages/rma/[uid].vue?macro=true";
import { default as _91txnUid_93Ff7LJ4AfJKzav1x5l45ELILl5Rts_R8rG9qA38vl1kAMeta } from "/usr/src/app/apps/site-sk/app/pages/sales/[txnUid].vue?macro=true";
import { default as _91uid_93shrOb4erY5Hzgy9ysjKtr4zrBUusp_xscMMF_jJYhusMeta } from "/usr/src/app/apps/site-sk/app/pages/shipment/[uid].vue?macro=true";
import { default as addresses3bGHgfoVKatifGHsXTHnov8Oi3_wyRhSO1EijUyXqjwMeta } from "/usr/src/app/apps/site-sk/app/pages/account/addresses.vue?macro=true";
import { default as agreementsibQs708DeOLCnV_tLoEO3boJ_f99wH6Yw1nimI7DwIEMeta } from "/usr/src/app/apps/site-sk/app/pages/account/agreements.vue?macro=true";
import { default as autopayRrXUIF1uUOFKBoymFfRty4XRzBK0y_p5HInDCeGKdBYMeta } from "/usr/src/app/apps/site-sk/app/pages/account/autopay.vue?macro=true";
import { default as balancenBCqHFiaHc8SjCQ_vcvDZ_MCpfJ9c5stAYy6lHfYMCAMeta } from "/usr/src/app/apps/site-sk/app/pages/account/balance.vue?macro=true";
import { default as bodiesxKcO2Ledzd9PY6ahuhzhllDZQXePx2ga3CTB2oOqSW0Meta } from "/usr/src/app/apps/site-sk/app/pages/account/bodies.vue?macro=true";
import { default as bulk_45orderVdQeJ4nVwTzkVXpUUfgYM497ZAsl4fdKlHsWoaeKuYAMeta } from "/usr/src/app/apps/site-sk/app/pages/account/bulk-order.vue?macro=true";
import { default as claimsLF_VOMWxE_tjc9TaE9itwfZ0BIrbSt_meizEjnRR4Y4Meta } from "/usr/src/app/apps/site-sk/app/pages/account/claims.vue?macro=true";
import { default as contact48GuFi7IToE0hUPZlraVeH_DZYXwJEWBSLYpA2_8JJQMeta } from "/usr/src/app/apps/site-sk/app/pages/account/contact.vue?macro=true";
import { default as credit_45memosih16g9K42x0K3rruE0xL0M30A8bCNccGH3QU5mw56uAMeta } from "/usr/src/app/apps/site-sk/app/pages/account/credit-memos.vue?macro=true";
import { default as customizations9vweatk8BnoNivNDSA7ojeQ2GxgGHGwudiJp8D1zlNAMeta } from "/usr/src/app/apps/site-sk/app/pages/account/customizations.vue?macro=true";
import { default as invoicesmO7inDh7ZKxKLKUeksukrikVJCYRJ20zgCh__EmD7h0Meta } from "/usr/src/app/apps/site-sk/app/pages/account/invoices.vue?macro=true";
import { default as manage_45membersyyVj4ZkGjEi8L52gJg4ewivIX22RVdSRLyFmR4aoif0Meta } from "/usr/src/app/apps/site-sk/app/pages/account/manage-members.vue?macro=true";
import { default as map_45policyQ6wP18Yf05UjjG2qx3KGDbBZJQVKr5A8gPV6xFZx39AMeta } from "/usr/src/app/apps/site-sk/app/pages/account/map-policy.vue?macro=true";
import { default as marketing_45assetshFBL3HjIa7TVHKO721g78uN3wfD8g3o70Kg4GdWikpcMeta } from "/usr/src/app/apps/site-sk/app/pages/account/marketing-assets.vue?macro=true";
import { default as order_45linesdJm9m_3jyIhcbhV7UHiJNKCbfhyH9oYsyLxHcdhzuPgMeta } from "/usr/src/app/apps/site-sk/app/pages/account/order-lines.vue?macro=true";
import { default as ordersW1fbSbliuk3HbIXxinxIdurhikc0rhEW5nErfT4jK0wMeta } from "/usr/src/app/apps/site-sk/app/pages/account/orders.vue?macro=true";
import { default as payment_45methods1fkeLaPeZr84Gq2_anBp4E7cljlnBSpZMl3sgIrpb_sMeta } from "/usr/src/app/apps/site-sk/app/pages/account/payment-methods.vue?macro=true";
import { default as pricing_45termswmPYGg4ZMoF9Ixe2qcH20D_GNbByMojylsUhBWUTw68Meta } from "/usr/src/app/apps/site-sk/app/pages/account/pricing-terms.vue?macro=true";
import { default as product_45launchesEmJF_8GU4xrhN3LFEakkVxuIoNxZFtELJ9ANF4SgpRwMeta } from "/usr/src/app/apps/site-sk/app/pages/account/product-launches.vue?macro=true";
import { default as product_45listHhAFUgr0DQEUXOadFbn4vfcbUyrQqENvJo4NQSmE3SYMeta } from "/usr/src/app/apps/site-sk/app/pages/account/product-list.vue?macro=true";
import { default as profileupcB7cyJ9Ozg33a0ArYqqe4SUyuO64sLxbOOpkhMkygMeta } from "/usr/src/app/apps/site-sk/app/pages/account/profile.vue?macro=true";
import { default as registrations3h_qGjTq3VGGrJTrBbMQYISGx2_4wwsjFlaL49D6dRoMeta } from "/usr/src/app/apps/site-sk/app/pages/account/registrations.vue?macro=true";
import { default as returnsK9p5x_qtvUISM_MrcznUTRH8FscbHw7psGP1M5Q0eOYMeta } from "/usr/src/app/apps/site-sk/app/pages/account/returns.vue?macro=true";
import { default as shipmentscDAHnh_ZzdrxplJy4mNZ57PqO_XbFwqv9RXbq_5r6csMeta } from "/usr/src/app/apps/site-sk/app/pages/account/shipments.vue?macro=true";
import { default as sku_45launches1s8BdUGU4DX0NqLz2Upjm___OO_Mjgsil8ak6sLQCz4Meta } from "/usr/src/app/apps/site-sk/app/pages/account/sku-launches.vue?macro=true";
import { default as sku_45list_YCJbeNF0_8XcvbFegFVgXsk7PvLWBnP61Iek3g6xJ0Meta } from "/usr/src/app/apps/site-sk/app/pages/account/sku-list.vue?macro=true";
import { default as subscriptionsEtphJaoU8PWSEYzCcpP5ETrWU11w8Fehg2aYlGcmylQMeta } from "/usr/src/app/apps/site-sk/app/pages/account/subscriptions.vue?macro=true";
import { default as third_45party_45marketplace_45policywtytAQ4deaUPNE00rumegyR_9l_qV7HHdwdWBQ4SRA0Meta } from "/usr/src/app/apps/site-sk/app/pages/account/third-party-marketplace-policy.vue?macro=true";
import { default as vouchersmK6pEmoMJNO_LecxxxODACCPs5p4msmadrx7C3iS2MQMeta } from "/usr/src/app/apps/site-sk/app/pages/account/vouchers.vue?macro=true";
import { default as account9wdXP68ikkaj7x_V_xq7oJ1HYzCLGRYVK5W607qSbZgMeta } from "/usr/src/app/apps/site-sk/app/pages/account.vue?macro=true";
import { default as cartJzD5VeS1YRP5jJfkePnBXItqcC2SezT_JDRKs34byosMeta } from "/usr/src/app/apps/site-sk/app/pages/cart.vue?macro=true";
import { default as checkoutAWhl9c3tfqZsco1z9MDpaDcZ4ZHmqZ_9HnAjlAi3rXgMeta } from "/usr/src/app/apps/site-sk/app/pages/checkout.vue?macro=true";
import { default as contact_fO5xquFQjCEgK1_uBGwgx1Kr4zeDTdXM7RxhHV_HAkMeta } from "/usr/src/app/apps/site-sk/app/pages/contact.vue?macro=true";
import { default as content65_njIxXgJi84czryQa9BKF1sq2aFoBn1E7sZ46CqcIMeta } from "/usr/src/app/apps/site-sk/app/pages/content.vue?macro=true";
import { default as cookie_45policytJTzHmm_c2mPrkFLf41nEd3gJxsfi0__P8iVsRRylm4Meta } from "/usr/src/app/apps/site-sk/app/pages/cookie-policy.vue?macro=true";
import { default as step_452WYAPt92bTRnEsr_Tg_7T40rnwr_cZvZkDgLD9L0iwMoMeta } from "/usr/src/app/apps/site-sk/app/pages/create-account/step-2.vue?macro=true";
import { default as indexAv_Y3x3ZQmza5QSUuHWXbWVJqJ2AVEMKxDniSWVzcTAMeta } from "/usr/src/app/apps/site-sk/app/pages/create-account/index.vue?macro=true";
import { default as create_45accounte7r_0UuGggkSxbawFbMm7_W2Ylv_P59nOjyW6fnY2dIMeta } from "/usr/src/app/apps/site-sk/app/pages/create-account.vue?macro=true";
import { default as faqSxfVGaj5t7xw2ks2R_pU9WTxK82uN_WHiqnmt2qGk5sMeta } from "/usr/src/app/apps/site-sk/app/pages/faq.vue?macro=true";
import { default as forgot_45password0T0iQweecLmRSsoLGqCr2z60LjbUjv78Ni98v5voixkMeta } from "/usr/src/app/apps/site-sk/app/pages/forgot-password.vue?macro=true";
import { default as jobs3xHCE7pUGeOJx4oAND1Kw9Qng6dUQZPcvnn97CfGn_oMeta } from "/usr/src/app/apps/site-sk/app/pages/jobs.vue?macro=true";
import { default as order_45statusH0EWwZx0Z9y_xdyM__qA73FuhTCzQ1nxCUOR_EwdIs8Meta } from "/usr/src/app/apps/site-sk/app/pages/order-status.vue?macro=true";
import { default as privacy_45policy_DNNGW9i0wsTSicJlmqblvRUdbb13qU0T_x8Q4GShk4Meta } from "/usr/src/app/apps/site-sk/app/pages/privacy-policy.vue?macro=true";
import { default as listjN4u_Y00cldFyZQTsBhkAQiyn_Y5tlB65hEldPYwtxkMeta } from "/usr/src/app/apps/site-sk/app/pages/product-catalog/list.vue?macro=true";
import { default as product_45catalogT_5AeUUwlo0_wVzy1t9Mnk6WyrnOVMnOHxnFiEFpBmYMeta } from "/usr/src/app/apps/site-sk/app/pages/product-catalog.vue?macro=true";
import { default as reset_45passwordsFimcDi1oDdVG5n_09Rm_PfKXOT6SGVJ7w3xbLEko9EMeta } from "/usr/src/app/apps/site-sk/app/pages/reset-password.vue?macro=true";
import { default as index0KQcfWZtNL1uHDpif8kxV0f3dXcTXoqQEfWtjaj26sYMeta } from "/usr/src/app/apps/site-sk/app/pages/return/index.vue?macro=true";
import { default as returnsP74gEpcXnPD5YGc3jebBEFm_wS4WOJoGrrkk4MNkPbAMeta } from "/usr/src/app/apps/site-sk/app/pages/returns.vue?macro=true";
import { default as reviewsi8dlckVzkCb05rsP5KyqWALI7vKdnF8tKlilLBRUMiEMeta } from "/usr/src/app/apps/site-sk/app/pages/reviews.vue?macro=true";
import { default as searchmtGQ4IRVRUJytnnb0MI86yRRcnyKc_L57x7w7jQSWxIMeta } from "/usr/src/app/apps/site-sk/app/pages/search.vue?macro=true";
import { default as set_45passwordK3WEt33pvWV1TGv3ALRMHj5hm7b_rYe_7_zOxMPaWx8Meta } from "/usr/src/app/apps/site-sk/app/pages/set-password.vue?macro=true";
import { default as sign_45incFgxebnqot1jwoDC2QL09Mqnjg5nXgUhlne1vzOQyn8Meta } from "/usr/src/app/apps/site-sk/app/pages/sign-in.vue?macro=true";
import { default as sign_45outMMo3l0eYK_GKpTkGm3Ypg1Lhp_Hmhoqn3jZv_5_F2_EMeta } from "/usr/src/app/apps/site-sk/app/pages/sign-out.vue?macro=true";
import { default as storesss4ji4zLTvzbstB91ILhDTJtS2Vv_GVVoOl11FkDz9QMeta } from "/usr/src/app/apps/site-sk/app/pages/stores.vue?macro=true";
import { default as subscriptionszuxhqoc1obkcB2LBWE6AxCEega51WbmdDtRdEn_3QGcMeta } from "/usr/src/app/apps/site-sk/app/pages/subscriptions.vue?macro=true";
import { default as indexjdLhdFogqNpqwe2l8o1JCFaY_BJiG6lZMAM5k56VRzUMeta } from "/usr/src/app/apps/site-sk/app/pages/support/index.vue?macro=true";
import { default as termsFhY0yEdYuzq9brUivX2KSYDzne3Hb9F2fxP2Q0yS0HQMeta } from "/usr/src/app/apps/site-sk/app/pages/terms.vue?macro=true";
import { default as indexcpcWNSbn9wmmk6rj_vIV3Lfs0pLXdg5oPT5xBB9CGloMeta } from "/usr/src/app/apps/site-sk/app/pages/index.vue?macro=true";
import { default as component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g } from "/usr/src/app/node_modules/.pnpm/nuxt@4.6.3_67a7375ff746f984e53749730d851ddb/node_modules/nuxt/dist/pages/runtime/component-stub.js";
import { default as component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta } from "/usr/src/app/node_modules/.pnpm/nuxt@4.6.3_67a7375ff746f984e53749730d851ddb/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
export default [
  {
    name: "cms-preview",
    path: "/cms/preview",
    meta: previewfyxoZ4798HWr52u2_PUHvx91MysEp7ADfjGcV4vaxUQMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/cms/preview.vue")
  },
  {
    name: "cms-preview-frame",
    path: "/cms/preview-frame",
    meta: preview_45frame7dTt7di272RbevGa9AHSLywnB5O6vUrvlYzddywTAoUMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/cms/preview-frame.vue")
  },
  {
    name: "onboarding-teams",
    path: "/onboarding/teams",
    meta: teamsQpBKgyG7Iqbx5NmXd_zuzpRgNNBkTpPIXSzTIiBkjvAMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/onboarding/teams.vue")
  },
  {
    name: "order-confirmation",
    path: "/order/confirmation/:order",
    meta: confirmationxrFy6XxLBrrYy1w165IrVudr8NC6g6znTSfh_KbzVSAMeta || {},
    alias: ["/order/confirmation/:order"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/order/confirmation.vue")
  },
  {
    name: "support-warranty",
    path: "/support/warranty",
    meta: warranty17iq113BMNrtd_byX81D62BxXsdEaFhuNu1bUwnvfsIMeta || {},
    alias: ["/support/warranty/submit-claim"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/support/warranty.vue")
  },
  {
    name: "accept-invitation-uid",
    path: "/accept-invitation/:uid()",
    meta: _91uid_936xZayM4q_hba2veOoUMptrinWJslT3v_XYM0VEMGZXMMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/accept-invitation/[uid].vue")
  },
  {
    name: "order-line-uid",
    path: "/order-line/:uid",
    meta: _91uid_93NpdWdLZPeZKF6TsmHEk_fovSfJVOCQ6f_L7y6jVoDmYMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/order-line/[uid].vue")
  },
  {
    name: "return-orderUid",
    path: "/return/:orderUid()",
    meta: _91orderUid_935PrLycAXHRbu_uxmpn2rHIUPJ8tjEfCIShJLkUMPdw4Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/return/[orderUid].vue")
  },
  {
    name: "rma-uid",
    path: "/rma/:uid()",
    meta: _91uid_93MvA_XjWWZYhHfLZx7WxNXcWQuTRrk5TjseWxLAuhuTsMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/rma/[uid].vue")
  },
  {
    name: "sales-txnUid",
    path: "/sales/:txnUid",
    meta: _91txnUid_93Ff7LJ4AfJKzav1x5l45ELILl5Rts_R8rG9qA38vl1kAMeta || {},
    alias: ["/order/:txnUid","/invoice/:txnUid","/credit-memo/:txnUid"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/sales/[txnUid].vue")
  },
  {
    name: "shipment-uid",
    path: "/shipment/:uid",
    meta: _91uid_93shrOb4erY5Hzgy9ysjKtr4zrBUusp_xscMMF_jJYhusMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/shipment/[uid].vue")
  },
  {
    name: "_debug",
    path: "/_debug",
    component: () => import("/usr/src/app/apps/site-sk/app/pages/_debug.vue")
  },
  {
    name: "_settings",
    path: "/_settings",
    component: () => import("/usr/src/app/apps/site-sk/app/pages/_settings.vue")
  },
  {
    name: account9wdXP68ikkaj7x_V_xq7oJ1HYzCLGRYVK5W607qSbZgMeta?.name,
    path: "/account",
    meta: { ...(account9wdXP68ikkaj7x_V_xq7oJ1HYzCLGRYVK5W607qSbZgMeta || {}), ...{"middleware":["auth","account-guard"]} },
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account.vue"),
    children: [
  {
    name: "account-addresses",
    path: "addresses",
    meta: addresses3bGHgfoVKatifGHsXTHnov8Oi3_wyRhSO1EijUyXqjwMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/addresses.vue")
  },
  {
    name: "account-agreements",
    path: "/account/agreements/:agreementUid?",
    meta: agreementsibQs708DeOLCnV_tLoEO3boJ_f99wH6Yw1nimI7DwIEMeta || {},
    alias: ["/account/agreements/:agreementUid?"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/agreements.vue")
  },
  {
    name: "account-autopay",
    path: "autopay",
    meta: autopayRrXUIF1uUOFKBoymFfRty4XRzBK0y_p5HInDCeGKdBYMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/autopay.vue")
  },
  {
    name: "account-balance",
    path: "balance",
    meta: balancenBCqHFiaHc8SjCQ_vcvDZ_MCpfJ9c5stAYy6lHfYMCAMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/balance.vue")
  },
  {
    name: "account-bodies",
    path: "bodies",
    meta: bodiesxKcO2Ledzd9PY6ahuhzhllDZQXePx2ga3CTB2oOqSW0Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/bodies.vue")
  },
  {
    name: "account-bulk-order",
    path: "bulk-order",
    meta: bulk_45orderVdQeJ4nVwTzkVXpUUfgYM497ZAsl4fdKlHsWoaeKuYAMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/bulk-order.vue")
  },
  {
    name: "account-claims",
    path: "claims",
    meta: claimsLF_VOMWxE_tjc9TaE9itwfZ0BIrbSt_meizEjnRR4Y4Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/claims.vue")
  },
  {
    name: "account-contact",
    path: "contact",
    meta: contact48GuFi7IToE0hUPZlraVeH_DZYXwJEWBSLYpA2_8JJQMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/contact.vue")
  },
  {
    name: "account-credit-memos",
    path: "credit-memos",
    meta: credit_45memosih16g9K42x0K3rruE0xL0M30A8bCNccGH3QU5mw56uAMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/credit-memos.vue")
  },
  {
    name: "account-customizations",
    path: "customizations",
    meta: customizations9vweatk8BnoNivNDSA7ojeQ2GxgGHGwudiJp8D1zlNAMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/customizations.vue")
  },
  {
    name: "account-invoices",
    path: "invoices",
    meta: invoicesmO7inDh7ZKxKLKUeksukrikVJCYRJ20zgCh__EmD7h0Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/invoices.vue")
  },
  {
    name: "account-manage-members",
    path: "manage-members",
    meta: manage_45membersyyVj4ZkGjEi8L52gJg4ewivIX22RVdSRLyFmR4aoif0Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/manage-members.vue")
  },
  {
    name: "account-map-policy",
    path: "map-policy",
    meta: map_45policyQ6wP18Yf05UjjG2qx3KGDbBZJQVKr5A8gPV6xFZx39AMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/map-policy.vue")
  },
  {
    name: "account-marketing-assets",
    path: "marketing-assets",
    meta: marketing_45assetshFBL3HjIa7TVHKO721g78uN3wfD8g3o70Kg4GdWikpcMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/marketing-assets.vue")
  },
  {
    name: "account-order-lines",
    path: "order-lines",
    meta: order_45linesdJm9m_3jyIhcbhV7UHiJNKCbfhyH9oYsyLxHcdhzuPgMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/order-lines.vue")
  },
  {
    name: "account-orders",
    path: "orders",
    meta: ordersW1fbSbliuk3HbIXxinxIdurhikc0rhEW5nErfT4jK0wMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/orders.vue")
  },
  {
    name: "account-payment-methods",
    path: "payment-methods",
    meta: payment_45methods1fkeLaPeZr84Gq2_anBp4E7cljlnBSpZMl3sgIrpb_sMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/payment-methods.vue")
  },
  {
    name: "account-pricing-terms",
    path: "pricing-terms",
    meta: pricing_45termswmPYGg4ZMoF9Ixe2qcH20D_GNbByMojylsUhBWUTw68Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/pricing-terms.vue")
  },
  {
    name: "account-product-launches",
    path: "product-launches",
    meta: product_45launchesEmJF_8GU4xrhN3LFEakkVxuIoNxZFtELJ9ANF4SgpRwMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/product-launches.vue")
  },
  {
    name: "account-product-list",
    path: "product-list",
    meta: product_45listHhAFUgr0DQEUXOadFbn4vfcbUyrQqENvJo4NQSmE3SYMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/product-list.vue")
  },
  {
    name: "account-profile",
    path: "profile",
    meta: profileupcB7cyJ9Ozg33a0ArYqqe4SUyuO64sLxbOOpkhMkygMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/profile.vue")
  },
  {
    name: "account-registrations",
    path: "registrations",
    meta: registrations3h_qGjTq3VGGrJTrBbMQYISGx2_4wwsjFlaL49D6dRoMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/registrations.vue")
  },
  {
    name: "account-returns",
    path: "returns",
    meta: returnsK9p5x_qtvUISM_MrcznUTRH8FscbHw7psGP1M5Q0eOYMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/returns.vue")
  },
  {
    name: "account-shipments",
    path: "shipments",
    meta: shipmentscDAHnh_ZzdrxplJy4mNZ57PqO_XbFwqv9RXbq_5r6csMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/shipments.vue")
  },
  {
    name: "account-sku-launches",
    path: "sku-launches",
    meta: sku_45launches1s8BdUGU4DX0NqLz2Upjm___OO_Mjgsil8ak6sLQCz4Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/sku-launches.vue")
  },
  {
    name: "account-sku-list",
    path: "sku-list",
    meta: sku_45list_YCJbeNF0_8XcvbFegFVgXsk7PvLWBnP61Iek3g6xJ0Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/sku-list.vue")
  },
  {
    name: "account-subscriptions",
    path: "subscriptions",
    meta: subscriptionsEtphJaoU8PWSEYzCcpP5ETrWU11w8Fehg2aYlGcmylQMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/subscriptions.vue")
  },
  {
    name: "account-third-party-marketplace-policy",
    path: "third-party-marketplace-policy",
    meta: third_45party_45marketplace_45policywtytAQ4deaUPNE00rumegyR_9l_qV7HHdwdWBQ4SRA0Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/third-party-marketplace-policy.vue")
  },
  {
    name: "account-vouchers",
    path: "vouchers",
    meta: vouchersmK6pEmoMJNO_LecxxxODACCPs5p4msmadrx7C3iS2MQMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/vouchers.vue")
  },
  {
    name: "account",
    path: "",
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/index.vue")
  }
]
  },
  {
    name: "cart",
    path: "/cart",
    meta: cartJzD5VeS1YRP5jJfkePnBXItqcC2SezT_JDRKs34byosMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/cart.vue")
  },
  {
    name: checkoutAWhl9c3tfqZsco1z9MDpaDcZ4ZHmqZ_9HnAjlAi3rXgMeta?.name,
    path: "/checkout",
    meta: checkoutAWhl9c3tfqZsco1z9MDpaDcZ4ZHmqZ_9HnAjlAi3rXgMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/checkout.vue"),
    children: [
  {
    name: "checkout",
    path: "",
    component: () => import("/usr/src/app/apps/site-sk/app/pages/checkout/index.vue")
  }
]
  },
  {
    name: "contact",
    path: "/contact",
    meta: contact_fO5xquFQjCEgK1_uBGwgx1Kr4zeDTdXM7RxhHV_HAkMeta || {},
    alias: ["/support/contact"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/contact.vue")
  },
  {
    name: "content",
    path: "/content/:catchAll(.*)",
    meta: content65_njIxXgJi84czryQa9BKF1sq2aFoBn1E7sZ46CqcIMeta || {},
    alias: ["/:catchAll(.*)"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/content.vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    meta: cookie_45policytJTzHmm_c2mPrkFLf41nEd3gJxsfi0__P8iVsRRylm4Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/cookie-policy.vue")
  },
  {
    name: create_45accounte7r_0UuGggkSxbawFbMm7_W2Ylv_P59nOjyW6fnY2dIMeta?.name,
    path: "/create-account",
    meta: create_45accounte7r_0UuGggkSxbawFbMm7_W2Ylv_P59nOjyW6fnY2dIMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/create-account.vue"),
    children: [
  {
    name: "create-account-step-2",
    path: "step-2",
    meta: step_452WYAPt92bTRnEsr_Tg_7T40rnwr_cZvZkDgLD9L0iwMoMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/create-account/step-2.vue")
  },
  {
    name: "create-account",
    path: "",
    meta: indexAv_Y3x3ZQmza5QSUuHWXbWVJqJ2AVEMKxDniSWVzcTAMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/create-account/index.vue")
  }
]
  },
  {
    name: "faq",
    path: "/faq",
    meta: faqSxfVGaj5t7xw2ks2R_pU9WTxK82uN_WHiqnmt2qGk5sMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/faq.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45password0T0iQweecLmRSsoLGqCr2z60LjbUjv78Ni98v5voixkMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/forgot-password.vue")
  },
  {
    name: "jobs",
    path: "/jobs",
    meta: jobs3xHCE7pUGeOJx4oAND1Kw9Qng6dUQZPcvnn97CfGn_oMeta || {},
    alias: ["/company/jobs"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/jobs.vue")
  },
  {
    name: "order-status",
    path: "/order-status",
    meta: order_45statusH0EWwZx0Z9y_xdyM__qA73FuhTCzQ1nxCUOR_EwdIs8Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/order-status.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policy_DNNGW9i0wsTSicJlmqblvRUdbb13qU0T_x8Q4GShk4Meta || {},
    alias: ["/privacy"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/privacy-policy.vue")
  },
  {
    name: "product-catalog",
    path: "/product-catalog",
    meta: product_45catalogT_5AeUUwlo0_wVzy1t9Mnk6WyrnOVMnOHxnFiEFpBmYMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/product-catalog.vue"),
    children: [
  {
    name: "product-catalog-list",
    path: "/product-catalog/:deeplink(.*)",
    meta: listjN4u_Y00cldFyZQTsBhkAQiyn_Y5tlB65hEldPYwtxkMeta || {},
    alias: ["/product-catalog/:deeplink(.*)"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/product-catalog/list.vue")
  }
]
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordsFimcDi1oDdVG5n_09Rm_PfKXOT6SGVJ7w3xbLEko9EMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/reset-password.vue")
  },
  {
    name: "return",
    path: "/return",
    meta: index0KQcfWZtNL1uHDpif8kxV0f3dXcTXoqQEfWtjaj26sYMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/return/index.vue")
  },
  {
    name: "returns",
    path: "/returns",
    meta: returnsP74gEpcXnPD5YGc3jebBEFm_wS4WOJoGrrkk4MNkPbAMeta || {},
    alias: ["/support/returns/"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/returns.vue")
  },
  {
    name: "reviews",
    path: "/reviews",
    meta: reviewsi8dlckVzkCb05rsP5KyqWALI7vKdnF8tKlilLBRUMiEMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/reviews.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: searchmtGQ4IRVRUJytnnb0MI86yRRcnyKc_L57x7w7jQSWxIMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/search.vue")
  },
  {
    name: "set-password",
    path: "/set-password",
    meta: set_45passwordK3WEt33pvWV1TGv3ALRMHj5hm7b_rYe_7_zOxMPaWx8Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/set-password.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: sign_45incFgxebnqot1jwoDC2QL09Mqnjg5nXgUhlne1vzOQyn8Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/sign-in.vue")
  },
  {
    name: "sign-out",
    path: "/sign-out",
    meta: sign_45outMMo3l0eYK_GKpTkGm3Ypg1Lhp_Hmhoqn3jZv_5_F2_EMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/sign-out.vue")
  },
  {
    name: "sms-consent",
    path: "/sms-consent",
    component: () => import("/usr/src/app/apps/site-sk/app/pages/sms-consent.vue")
  },
  {
    name: "stores",
    path: "/stores",
    meta: storesss4ji4zLTvzbstB91ILhDTJtS2Vv_GVVoOl11FkDz9QMeta || {},
    alias: ["/retailers/stores"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/stores.vue")
  },
  {
    name: "subscriptions",
    path: "/subscriptions",
    meta: subscriptionszuxhqoc1obkcB2LBWE6AxCEega51WbmdDtRdEn_3QGcMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/subscriptions.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexjdLhdFogqNpqwe2l8o1JCFaY_BJiG6lZMAM5k56VRzUMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/support/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termsFhY0yEdYuzq9brUivX2KSYDzne3Hb9F2fxP2Q0yS0HQMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/terms.vue")
  },
  {
    name: "va-products",
    path: "/va-products",
    component: () => import("/usr/src/app/apps/site-sk/app/pages/va-products.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexcpcWNSbn9wmmk6rj_vIV3Lfs0pLXdg5oPT5xBB9CGloMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/index.vue")
  },
  {
    name: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta?.name,
    path: "/terms-of-use",
    component: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g
  },
  {
    name: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta?.name,
    path: "/retail",
    component: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g
  },
  {
    name: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta?.name,
    path: "/about-us",
    component: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g
  },
  {
    name: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta?.name,
    path: "/account/manage-team",
    component: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g
  },
  {
    name: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta?.name,
    path: "/warranty",
    component: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g
  },
  {
    name: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta?.name,
    path: "/redeem",
    component: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g
  },
  {
    name: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta?.name,
    path: "/ustring/:pathMatch(.*)",
    component: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g
  },
  {
    name: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta?.name,
    path: "/register",
    component: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g
  },
  {
    name: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta?.name,
    path: "/support/register",
    component: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g
  },
  {
    name: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta?.name,
    path: "/va-products/level-4-sterile-surgical-gowns/:pathMatch(.*)",
    component: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g
  },
  {
    name: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta?.name,
    path: "/va-products/level-3-sterile-surgical-gowns/:pathMatch(.*)",
    component: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g
  },
  {
    name: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta?.name,
    path: "/va-products/level-2-isolation-gowns/:pathMatch(.*)",
    component: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g
  },
  {
    name: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta?.name,
    path: "/va-products/level-3-surgical-mask/:pathMatch(.*)",
    component: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g
  },
  {
    name: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta?.name,
    path: "/va-products/over-the-head-protective-gowns/:pathMatch(.*)",
    component: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g
  },
  {
    name: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0gMeta?.name,
    path: "/symbols",
    component: component_45stubSAT6gpnnp7jBqqbtvznEGMZAgfi7Z_Q5PhKpUxttx0g
  }
]